/* eslint-disable @typescript-eslint/no-explicit-any */
export interface  ApiResponseDefault<T> {
	ok?: boolean;
	statusCode?: number,
	erros?: any;
	data?: T
}
